import { useActiveJob } from "@/contexts/ActiveJobContext";
import React from "react";

interface HeaderProps {
  showJobPosting?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showJobPosting = true }) => {
  const { job } = useActiveJob();
  return (
    <header className="mb-6 bg-[#FFBE37] py-8 relative overflow-hidden rounded-lg">
      {/* Background image pattern */}
      <div className="absolute inset-0 opacity-100 rounded-lg overflow-hidden flex items-center justify-center">
        <img
          src="/images/Hived-outline.svg"
          alt="Background pattern"
          className="min-w-full min-h-full object-cover scale-[0.99] md:scale-[0.50]"
        />
      </div>

      <div className="container mx-auto flex flex-col items-center px-4 relative z-10">
        <img
          src="/images/Hived-logo.svg"
          alt="Hived Logo"
          className="w-20 h-20 mb-2"
        />

        {/* Title */}
        <h1 className="text-black text-xl font-semibold mb-1">
          Application Portal
        </h1>

        {/* Subtitle - conditionally rendered */}
        {showJobPosting && (
          <h2 className="text-black text-lg md:text-2xl font-bold text-center">
            {job?.title}
          </h2>
        )}
      </div>
    </header>
  );
};

export default Header;
